// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { orderSummaryProps } from "@store/Themes/common/props/order";
import QuoteLinkBold from "@store/Library/Components/Toolkit/Icons/QuoteLinkBold";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    quoteState: getQuoteState(state, state.pages.rfqConfirmation.quoteId),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface RfqSummaryStyles {
    quoteWrapper?: InjectableCss;
    titleWrapper?: InjectableCss;
    title?: TypographyProps;
    itemWrapper?: InjectableCss;
    quoteProductLabel?: TypographyProps;
    quoteIcon?: IconPresentationProps;
    quoteProductValue?: TypographyProps;
    priceOnQuoteWrapper?: InjectableCss;
    priceOnQuoteLabel?: TypographyProps;
}

export const rfqSummaryStyles: RfqSummaryStyles = {
    quoteWrapper: {
        ...orderSummaryProps.wrapper,
        css: css`
            ${orderSummaryProps.wrapper?.css}
            box-shadow: none;
            border-radius: ${pxToRem(10)};
            background-color: ${getColor("common.accent")};
            margin-bottom: ${pxToRem(24)};
        `,
    },
    titleWrapper: orderSummaryProps.titleWrapper,
    title: orderSummaryProps.title,
    itemWrapper: orderSummaryProps.itemWrapper,
    quoteProductLabel: {
        ...orderSummaryProps.itemLabel,
        css: css`
            ${orderSummaryProps.itemLabel?.css}
            display: flex;
            align-items: center;
        `,
    },
    quoteIcon: {
        src: QuoteLinkBold,
        size: 18,
        css: css`
            margin-right: ${pxToRem(5)};
        `,
    },
    quoteProductValue: orderSummaryProps.itemValue,
    priceOnQuoteWrapper: {
        css: css`
            background-color: ${getColor("common.background")};
            border-radius: ${pxToRem(8)};
            padding: ${pxToRem(16, 12)};
            font-size: ${x => x.theme.design.typography.size.smaller};
        `,
    },
    priceOnQuoteLabel: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.semibold};
            display: block;
        `,
    },
};

const styles = rfqSummaryStyles;

const RfqSummary: FC<Props> = ({ quoteState }) => {
    if (!quoteState.value) {
        return null;
    }

    return (
        <StyledWrapper {...styles.quoteWrapper}>
            <StyledWrapper {...styles.titleWrapper}>
                <Typography {...styles.title}>{translate("Quote Summary")}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.itemWrapper}>
                <Typography {...styles.quoteProductLabel}>
                    <Icon {...styles.quoteIcon} />
                    {translate("Product require quote")}
                </Typography>
                <Typography {...styles.quoteProductValue}>{quoteState.value.cartLines?.length}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.itemWrapper}>
                <Typography {...styles.quoteProductLabel}>{translate("Estimated total")}</Typography>
                <Typography {...styles.quoteProductValue}>{quoteState.value.orderSubTotalDisplay}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.priceOnQuoteWrapper}>
                <Typography {...styles.priceOnQuoteLabel}>{translate("Price on quote")}</Typography>
                <Typography>{translate("Price varies depending on configuration / quantity")}</Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RfqSummary),
    definition: {
        group: "RFQ Quote Confirmation",
        allowedContexts: ["RfqConfirmationPage"],
        displayName: "Summary",
    },
};

export default widgetModule;
